import image1 from '../assets/images/finenetvpn.png';
const siteOptionData = [
    {
      id: 1,
      siteName: "FINE NET LTD.",
      image: image1,
      description: "খুব সহজে ডাউনলোড করতে পারবেন। নিচে লিংক এ ক্লিক করেন &  পুরো ভিডিও দেখেন",
      siteLink: "https://youtu.be/E38rF3sB06Q?si=W0OI_p5jRyR9dl5t"
    }
  ];
  export default siteOptionData;
